import { api } from "api/api";
import { AxiosError } from "axios";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Usuario from "model/administracao/cadastro/Usuario";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class CentroCustoService implements BaseServiceCadastros<CentroCusto> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/centrocusto/pesquisar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<CentroCusto>((resolve, reject): void => {
            api
                .get(`/centrocusto/consultar/${id}`)
                .then(response => {
                    const centroCusto: CentroCusto = response.data;
                    centroCusto.centroCustoUsuarios.forEach(item => {
                        item.key = generateKey();
                        return item;
                    });
                    resolve(centroCusto);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(centroCusto: CentroCusto) {
        return new Promise<CentroCusto>((resolve, reject): void => {
            let url = `/centrocusto/incluir`;
            api
                .post(url, JSON.stringify(centroCusto))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(centroCusto: CentroCusto) {
        return new Promise<CentroCusto>((resolve, reject): void => {
            api
                .put(`/centrocusto/editar`, JSON.stringify(centroCusto))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/centrocusto/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/centrocusto/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default CentroCustoService;
